import { render, staticRenderFns } from "./zContainer.vue?vue&type=template&id=a067ce8a&scoped=true&"
import script from "./zContainer.vue?vue&type=script&lang=js&"
export * from "./zContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a067ce8a",
  null
  
)

export default component.exports